import { NewsCategory } from "../../interfaces/restaurantNews";

// Shared by the dashboard's "À ne pas manquer" widget and the Actualité CHR board.
export const NEWS_CATEGORY_LABEL: Record<NewsCategory, string> = {
    opening: "Ouverture",
    closing: "Fermeture",
    ownership: "Reprise",
    recruitment: "Recrutement",
    all: "Actu",
};

export const NEWS_CATEGORY_TONE: Record<NewsCategory, "success" | "danger" | "warning" | "info" | "neutral"> = {
    opening: "success",
    closing: "danger",
    ownership: "warning",
    recruitment: "info",
    all: "neutral",
};

export function newsTimeAgo(dateStr: string): string {
    const diff = Date.now() - new Date(dateStr).getTime();
    const hours = Math.floor(diff / 3600000);
    if (hours < 1) return "à l'instant";
    if (hours < 24) return `il y a ${hours}h`;
    const days = Math.floor(hours / 24);
    if (days === 1) return "hier";
    return `il y a ${days}j`;
}

/**
 * Time between the establishment's opening (its INSEE creation date) and the article: `days` > 0
 * when the article came after (the usual case), < 0 when it announced a place not yet open. `label` is the span alone
 * ("18 j", "4 mois", "2 ans", "même jour").
 */
export function openingGap(openingDate: string | null | undefined, published: string): { days: number; label: string } | null {
    if (!openingDate) return null;
    const days = Math.round((new Date(published).getTime() - new Date(openingDate).getTime()) / 86_400_000);
    if (Number.isNaN(days)) return null;
    const span = Math.abs(days);
    const label = span === 0 ? "même jour" : span < 45 ? `${span} j` : span < 730 ? `${Math.round(span / 30.4)} mois` : `${Math.floor(span / 365)} ans`;
    return { days, label };
}
